var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-loaded-wrapper d-flex justify-content-center align-items-center w-100 h-100"},[_c('div',{staticClass:"half-circle-spinner"},[_c('div',{staticClass:"circle circle-1"}),_c('div',{staticClass:"circle circle-2"})])])
}]

export { render, staticRenderFns }